import { SupplierSubscriptionPlanMessage } from './types/SupplierSubscriptionPlanMessage';

export const hasSupplierSubscriptionPlanSpecialOffer = (plan: SupplierSubscriptionPlanMessage): boolean =>
    plan.specialOfferValidUntil !== undefined;
